// This is compiled by parcel with `npm run build` or `npm run dev`

// Import scripts

import "/assets/scripts/js/init-foundation.js"; // initiates foundation js
import "/assets/scripts/js/wp-foundation.js"; //
import "/assets/scripts/js/lozad.js";
import "/assets/scripts/js/lead-source.js"; // lead source
import "/assets/scripts/js/aos.js"; // animations
import "/assets/scripts/js/mobile-menu.js";


import "/components/counting-numbers/scripts";
import "/components/tabbed-section/scripts";
import "/components/carousel/scripts";
import "/components/video-header-banner/scripts";
import "/components/related-blogs/scripts";

import "/assets/scripts/js/lity.js";
import "/assets/scripts/js/main.js";


// Import styles

import "./node_modules/aos/dist/aos.css";
import "./assets/styles/scss/style.scss";
